import { server } from '../engine/server'
import { modal } from '../utilities/modal'
import { browserHistory } from 'react-router'

var Warranties = Class.create({
  	initialize: function() {
	},
	getWarranties: function(callback) {
		var url = "warranties/all";
		var data = server.getData(url,null,false);
		data
		.done(function(response){
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
                modal.showInfo("Oops! " + response.data.error, "danger", "top", "center");
			} else {
                if(callback) {
                    callback(response);
                }
            }
		})
		.fail(function(e){
			modal.showInfo("Oops! " + e.responseText, "danger", "top", "center");
		});
    },
    getWarranty: function(warranty_id, callback) {
        var url = "warranty/" + warranty_id;
		var data = server.getData(url, null, true);
		data
		.done(function(response){
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
                modal.showInfo("Oops! " + response.data.error, "danger", "top", "center");
			} else {
                if(callback) {
                    callback(response);
                }
            }
		})
		.fail(function(e){
			modal.showInfo("Oops! " + e.responseText, "danger", "top", "center");
		});
    },
    saveWarranty: function(warrantyData, callback) {
        var url = "warranty/new";

        var params = warrantyData;
        var data = server.getData(url, params, true, 'POST');
        data
        .done(function(response){
            if(response.data.error_user_authentication == 1) {
            }
            else if(response.data.error || (response.status == 1 || response.status == 2)) {
                modal.showInfo("Oops! " + response.data.error, "danger", "top", "center");
            } else {
                if(callback) {
                    callback(response.data.warranty_id);
                }
            }
        })
        .fail(function(e){
            modal.resetBackDrop();
            modal.showInfo("Oops! " + e.responseText, "danger", "top", "center");
        });
    },
    updateWarranty: function(warrantyData, callback) {
        modal.showDangerModalWithOK("Are you sure?","You are about to update this warranty.","Yes, Update");
        jQuery(".move-on").on('click',function() {
            var url = "warranty/" + warrantyData.warranty_id + "/update";
            var params = warrantyData;
            var data = server.getData(url, params, true, 'POST');
            data
            .done(function(response){
                if(response.data.error_user_authentication == 1)
                {
                }
                else if(response.data.error || (response.status == 1 || response.status == 2))
                {
                    modal.showInfo("Oops! " + response.data.error), "danger", "top", "center";
                } else {
                    if(callback) {
                        modal.resetBackDrop();
                        modal.showSuccess("Warranty Updated!","This warranty has been successfully updated.");
                        callback(response);
                    }
                }
            })
            .fail(function(e){
                modal.resetBackDrop();
                modal.showInfo("Oops! " + e.responseText, "danger", "top", "center");
            });
        });
    },
    getWarrantyStats: function(callback) {
        var url = "warranties/stats";
		var data = server.getData(url, null, true);
		data
		.done(function(response){
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
                modal.showInfo("Oops! " + response.data.error, "danger", "top", "center");
			} else {
                if(callback) {
                    callback(response);
                }
            }
		})
		.fail(function(e){
			modal.showInfo("Oops! " + e.responseText, "danger", "top", "center");
		});
    },
    deleteWarranty: function(warrantyId){
      modal.showDangerModalWithOK("Are you sure?","You are about to delete this warranty.","Yes, Delete");
      jQuery(".move-on").on('click',function() {
		var url = "warranties/" + warrantyId;
		var data = server.getData(url,null,true, "DELETE");
        data
        .done(function(response){
            if(response.status == 1 || response.status == 2)
            {
                modal.showInfo("Oops! Something went wrong!", "danger", "top", "center");
            }
            else if(response.data.error != null)
            {
                modal.showInfo("Error occurred: " + response.data.error + ". Please try again", "danger", "top", "center");
            }
            else
            {
                modal.resetBackDrop();
                modal.showSuccess("Warranty Deleted!","This warranty has been dropped. All associated information with this warranty has been removed.");
                jQuery(".move-on").on('click',function() {
                    browserHistory.goBack();
                });
            }
            })
            .fail(function(e){
                modal.showInfo("Oops! Something went wrong!", "danger", "top", "center");
            });
        });
	},
});

export let warranties = new Warranties();


// WEBPACK FOOTER //
// app/core/controllers/Warranties.js